import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { StatusCriteria } from './filter-status.model';
import { TreeNode } from 'primeng/api';
import { TreeViewService } from '@services/treeview.service';
import { FilterService } from '@services/filter.service';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterUtilService } from '../shared/filter-util.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { LookupService } from '@services/lookup.service';
import { AppState } from '../../../reducers';
import { select, Store } from '@ngrx/store';
import { selectSearchStrategyDatabaseIds } from '../../analysis/search-strategy/state/study-search-strategy.selectors';
import { DatabaseType } from '../../_study_constants';

@Component({
  selector: 'app-filter-status',
  templateUrl: './filter-status.component.html',
  styleUrls: ['./filter-status.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  encapsulation: ViewEncapsulation.None,
})
export class FilterStatusComponent implements OnInit, OnDestroy {
  @Input() filter: any;
  @Input() submitClicked: boolean;
  @Input() readOnly = false;

  public statuses: TreeNode[];
  public selectedStatuses: TreeNode[] = [];
  public isNonBvdSelected: boolean;
  public selectedDatabaseIds: number[] = [];

  formDirty = false;
  private destroy$ = new Subject();

  constructor(
    private treeviewService: TreeViewService,
    private filterService: FilterService,
    private filterUtilService: FilterUtilService,
    private lookupService: LookupService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectSearchStrategyDatabaseIds))
      .subscribe((ids) => {
        this.selectedDatabaseIds = ids;
      });

    this.loadInitialData();
  }

  loadInitialData() {
    this.filterUtilService.spinnerRS.next(true);

    const getCompustatStatuses$ = this.filterService.getCompustatStatuses$(this.readOnly);
    const getStatuses$ = this.filterService.getStatuses$(this.readOnly);
    const isNonBvdDatabase$ = this.lookupService.isNonBvdDatabase(this.selectedDatabaseIds);

    forkJoin([isNonBvdDatabase$, getCompustatStatuses$, getStatuses$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([_isNonBvdSelected, _compustatStatus, _status]) => {
        this.isNonBvdSelected = _isNonBvdSelected;
        if (this.isNonBvdSelected && this.selectedDatabaseIds.find((s) => s != DatabaseType.OneSource)) {
          this.statuses = _compustatStatus;
        } else {
          this.statuses = _status;
        }
        this.initializeForm();
        this.filterUtilService.spinnerRS.next(false);
      });
  }

  initializeForm() {
    this.resetSelectedStatus(this.filter);
  }
  /** Status Filter**/
  statusNodeSelect() {
    this.resetFilterStatusSelection();
  }

  statusNodeUnSelect(isSelectedFromLeft: boolean) {
    const filter = <StatusCriteria>this.filter;
    if (isSelectedFromLeft) {
      this.resetFilterStatusSelection();
    } else {
      this.resetSelectedStatus(filter);
    }
  }

  resetSelectedStatus(filter: StatusCriteria) {
    if (filter.statusSelection) {
      this.selectedStatuses = [];
      const tmp = filter.statusSelection.filter((a) => a.data !== -1).map((a) => a.data);
      this.treeviewService.checkNodeForUnSelect(this.statuses, tmp, this.selectedStatuses);
      this.sortSelection(filter.statusSelection);
    }
  }

  resetFilterStatusSelection() {
    const filter = <StatusCriteria>this.filter;

    filter.statusSelection = [];

    const tmp = this.selectedStatuses.filter((a) => a.data !== '-1').map((a) => a.data);

    this.selectedStatuses = [];

    this.treeviewService.checkNodeForUnSelect(this.statuses, tmp, this.selectedStatuses);

    this.selectedStatuses.forEach((val) => {
      if (val.data !== '-1') {
        if (!filter.statusSelection || filter.statusSelection.filter((a) => a.data === val.data).length === 0) {
          filter.statusSelection.push(val);
        }
      }
    });

    this.sortSelection(filter.statusSelection);
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtilService.sortSelection(selection);
  }
  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
